export default "__VITE_ASSET__BX6Y7BT$__"